

const textarea = require('../textarea/textarea');

const richtext = Object.assign({}, textarea, {
    subelements: {},
    ckeditor: false,
    
    init: function () {
        textarea.init.call(this);
        csbCkEditor.create(this.element);
    }
});

module.exports = richtext;

